import { render, staticRenderFns } from "./PracticeVed.vue?vue&type=template&id=942d93f2&scoped=true&"
import script from "./PracticeVed.vue?vue&type=script&lang=js&"
export * from "./PracticeVed.vue?vue&type=script&lang=js&"
import style0 from "./PracticeVed.vue?vue&type=style&index=0&id=942d93f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "942d93f2",
  null
  
)

export default component.exports